export default {
  TimesPluralization: 'ကြိမ်ရေ | ကြိမ်ရေ',
  PointsPluralization: 'ပွိုင့် | ပွိုင့်'
}
